import { AmplitudeEvent } from "./AmplitudeEvent";

export class WorkStyleResultsViewedEvent extends AmplitudeEvent {
	static TEAM_DETAILS_LOCATION = "team details";
	static IN_MEETING_LOCATION = "in-meeting";

	constructor( viewLocation ) {
		if ( ![ WorkStyleResultsViewedEvent.TEAM_DETAILS_LOCATION, WorkStyleResultsViewedEvent.IN_MEETING_LOCATION, ].includes( viewLocation ) ) {
			throw new Error( `invalid view location: ${viewLocation}` );
		}
		super();
		this.name = "Individual Work Style Results Viewed";
	}
}



// WEBPACK FOOTER //
// ./src/telemetry/WorkStyleResultsViewedEvent.js